module.exports = __webpack_public_path__ + "static/6-3bae955156f7ae6e6e725d18ce4d39b6.jpg";